export default {
  BOX: 'box',
}
